import $ from 'jquery'
window.addEventListener('load',  function() {
    $('.js_select_greeting').click(function() {
        $("textarea[name='funeral[description]']").val($(this).closest('.card-body').find('p').text());
    });
})